import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type SdkParams = {
  platform?: string;
  accountId?: string;
  language: string;
  filter?: string;
  theme?: string;
  recaptcha?: 'true' | 'false';
  count?: string;
};

export type SdkState = {
  filter: Record<string, string> | null;
  params: SdkParams;
  scriptVersion: number;
  theme: Record<string, unknown> | null;
};

const initialState: SdkState = {
  filter: null,
  params: {
    language: '',
    count: '4',
  },
  scriptVersion: 0,
  theme: null,
};

const parseFilter = (params: SdkParams) => {
  let result: Record<string, string> | null = null;
  if (params.filter) {
    try {
      result = JSON.parse(params.filter);
    } catch {
      // ignore
    }
  }
  if (params.accountId) {
    if (!result) {
      result = {};
    }
    result.accountId = params.accountId;
  }
  return result;
};

const parseTheme = (params: SdkParams) => {
  if (params.theme) {
    try {
      return JSON.parse(params.theme);
    } catch {
      // ignore
    }
  }
  return null;
};

export const sdkSlice = createSlice({
  name: 'sdk',
  initialState: initialState,
  reducers: {
    setParams: (state, action: PayloadAction<SdkParams>) => {
      state.params = action.payload;
      state.filter = parseFilter(action.payload);
      state.theme = parseTheme(action.payload);
    },
    reloadScript: (state) => {
      state.scriptVersion++;
    },
  },
});

export const sdkActions = sdkSlice.actions;
